const handlePayment = async (orderDetails) => {
  return new Promise(async (resolve, reject) => {
    try {
      const orderInfo = orderDetails;
      const existingScript = document.querySelector(
        'script[src="https://checkout.razorpay.com/v1/checkout.js"]',
      );

      if (!existingScript) {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);
        await new Promise((scriptResolve, scriptReject) => {
          script.onload = scriptResolve;
          script.onerror = scriptReject;
        });
      } else if (!window.Razorpay) {
        await new Promise((scriptResolve, scriptReject) => {
          existingScript.addEventListener("load", scriptResolve, { once: true });
          existingScript.addEventListener("error", scriptReject, { once: true });
        });
      }

      const options = {
        key: "rzp_live_S4ythIYcRBEuys", // Replace with your Key ID
        amount: orderInfo.amount,
        currency: orderInfo.currency,
        name: "Digital Moi Tech",
        description: "",
        order_id: orderInfo.order_id,
        handler: function (response) {
          resolve({ status: 200, response });
        },
        prefill: {
          name: localStorage.getItem("org-name") || "",
          email: localStorage.getItem("org-email") || "",
          contact: localStorage.getItem("org-phone") || "",
        },
      };

      window.scrollTo({ top: 0, behavior: "smooth" });
      const rzp = new window.Razorpay(options);
      setTimeout(() => {
        rzp.open();
      }, 150);
    } catch (error) {
      reject({ status: 500, error });
    }
  });
};

export default handlePayment;
